import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { DatePicker } from '@mui/x-date-pickers';
import Alert from 'feature/dispatching/components/Alert';
import { addYears, parseISO, startOfDay, startOfToday, subYears } from 'date-fns';
import DocumentUpload from './DocumentUpload';
import DownloadTemplatesTooltip from './DownloadTemplatesTooltip';

const DocumentsForm = ({
  documents,
  effectiveDate,
  onEffectiveDateChange,
  onMethod27Upload,
  onWetTestUpload,
  title,
  validationText,
}) => {
  return (
    <>
      <Box px={3}>
        {title && (
          <Stack direction="row" sx={{ alignItems: 'center', mb: 2 }}>
            <Typography>{title}</Typography>
            <DownloadTemplatesTooltip />
          </Stack>
        )}
        <DocumentUpload
          document={documents.wetTest}
          key="wetTest"
          label="Wet Test"
          onUpload={onWetTestUpload}
          type="WT"
        />
        <DocumentUpload
          document={documents.method27}
          key="method27"
          label="Method27"
          onUpload={onMethod27Upload}
          type="M27"
        />
      </Box>
      <Box pb={3} px={3}>
        <Typography sx={{ mb: 2, mt: 3 }} variant="body1">
          Effective Date
        </Typography>
        <Box width={1}>
          <DatePicker
            autoOk
            disableToolbar
            format="MM/dd/yyyy"
            htmlFor="effective-date"
            id="effective-date"
            InputAdornmentProps={{
              position: 'end',
              sx: {
                '&.MuiInputAdornment-root button': {
                  color: 'graphic.icons',
                },
              },
            }}
            minDate={subYears(startOfToday(), 1)}
            onChange={onEffectiveDateChange}
            slotProps={{
              textField: {
                error: addYears(parseISO(effectiveDate), 1) < new Date(),
                fullWidth: true,
                helperText: validationText,
                placeholder: '--',
              },
            }}
            value={startOfDay(parseISO(effectiveDate))}
            variant="inline"
          />
        </Box>
        <Box mt={2}>
          <Alert icon={false} severity="warning" variant="outlined">
            The Certification Status will expire a year from the Effective Date at 11:59pm and will
            need to be renewed.
          </Alert>
        </Box>
      </Box>
    </>
  );
};

DocumentsForm.propTypes = {
  documents: PropTypes.shape({
    method27: PropTypes.shape({}),
    wetTest: PropTypes.shape({}),
  }).isRequired,
  effectiveDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onEffectiveDateChange: PropTypes.func.isRequired,
  onMethod27Upload: PropTypes.func.isRequired,
  onWetTestUpload: PropTypes.func.isRequired,
  title: PropTypes.string,
  validationText: PropTypes.string,
};
DocumentsForm.defaultProps = {
  effectiveDate: null,
  title: undefined,
  validationText: null,
};

export default DocumentsForm;
